import "url-polyfill"
import Vue from "vue"
import VueI18n from "vue-i18n"
import events from "@/bl-events"
import Smartbanner from "@/features/smartbanner/components/smartbanner"
import getLocale from "@/utils/locale"
import { os as getOs } from "@/utils/user-agent"
import { cookie } from "@/utils/cookie"
import { init as initAdjust } from "@/utils/adjust-links"
import globals from "@/utils/globals"
import { adjustLinks } from "@blinkist/frontend-helpers"

Vue.use(VueI18n)

const os = getOs()
const COOKIE_NAME = "sb-closed"
const COOKIE_LIFE_TIME = 30
const PIWIK_EVENT_CATEGORY = "header-20190405-smartbanner"
const blackListedPageClasses = [
  "body.landing_pages__show",
  "body.purchase",
  "body.article_pages__show",
  "body.login__signup"
]

initAdjust()

const init = (config) => {
  if (["ios", "android"].indexOf(os) < 0) {
    return
  }

  if (cookie(COOKIE_NAME)) {
    return
  }

  if (document.querySelector(blackListedPageClasses.join(","))) {
    return
  }

  if (!globals.smartbanner) {
    return
  }

  if (globals.smartbannerDisabled) {
    return
  }

  if (globals.smartbannerParam) {
    const urlParams = new URLSearchParams(window.location.search)
    const smartbannerEnabled = urlParams.get(globals.smartbannerParam)

    if (smartbannerEnabled !== "1") {
      return
    }
  }

  const el = document.getElementById("smartbanner")

  if (!el) {
    return
  }

  const storeLink = adjustLinks.generateAdjustUrl({
    buttonCode: PIWIK_EVENT_CATEGORY,
    abTestVariations: config.test_categories,
    fingerprint: config.fingerprint,
    useClassicLink: true
  })

  const platform = os

  new Vue({
    name: "SmartbannerInit",
    el,
    i18n: new VueI18n({ locale: getLocale() }),
    render(h) {
      return h(Smartbanner, {
        props: {
          platform,
          rating: globals.smartbanner.rating[os].stars,
          ratingsCount: globals.smartbanner.rating[os].count,
          storeLink,
          onClose: () => {
            cookie(COOKIE_NAME, true, { expires: COOKIE_LIFE_TIME })
            events.track(PIWIK_EVENT_CATEGORY, "close")
            events.emit("smartbanner:close")
          }
        }
      })
    }
  })
}

export default init
